import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as kanbanActions from '../../../componentes/dragdrog/store/kanban.action';
import * as organizarActions from '../../../componentes/dragdrog/organizarLote/store/organizar.action';
import InclusaoPage from './inclusao.page';
import HistologiaApi from '../common/histologia.api';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import WebapiCommon from '@common/util/webapi.common';
import CommonFunctions from '@common/util/functions.common';
import { quadroKanbanEnum, colorsSystem } from '@common/util/defaultValues';
import '../common/histologia.styles.css';
import Card from './Card';
import Preview from '@componentes/PreviewURL';
import IntlMessage from "../../../helpers/intlMessage";
import { changePeriod, getDate, obterListagemDePeriodos, validarData } from '../../../helpers';
import {
	getOrdenacaoKanban,
	setOrdenacaoKanban,
  } from '../../../localStorage.util';

class InclusaoContainer extends Component {
	constructor(props) {
		super(props);

		const periodo = CommonFunctions.getPeriodosSubDays(0);

		this.state = {
			lista: [],
			tecnicos: [],
			tecnicoSelecionado: '',
			usuarioLocal: null,
			periodoInicial: periodo.periodoInicial,
			periodoFinal: periodo.periodoFinal,
			modalOpenCancelar: false,
			modalOpenNaoConfor: false,
			numeroDoExame: '',
			numeroDoPedido: '',
			sortAsc: getOrdenacaoKanban(),
			altura: '',
			mudou: false,
			periodo: { value: 'hoje', label: `${this.props.intl.formatMessage({ id: "period.today" })}` },
			periodos: []
		};

		this.getDate = getDate.bind(this);
		this.changePeriod = changePeriod.bind(this);
		this.obterListagemDePeriodos = obterListagemDePeriodos.bind(this);
		this.validarData = validarData.bind(this);
		this.periodoAlterado(this.state.periodo);
	}

	componentDidMount() {
		let usuarioLocalStorage = getUsuarioLocalStorage();
		if (usuarioLocalStorage === null) {
			this.props.commonActions.showFadeCarregando(false);
			this.props.history.push('/' + process.env.REACT_APP_LOGINPAGE);
		} else {
			HistologiaApi.getUsuario().then(usuarios => {
				this.props.commonActions.showFadeCarregando(false);
				var ts = usuarios.find(
					user => user.value === usuarioLocalStorage.usuarioId
				);
				this.setState({
					tecnicos: [{ value: null, label: `${this.props.intl.formatMessage({ id: "dashboards.cytology.technical" })}` }, ...usuarios],
					tecnicoSelecionado: { value: null, label: `${this.props.intl.formatMessage({ id: "dashboards.cytology.technical" })}` },
					usuarioLocal: ts ? ts.value : null,
					usuario: usuarioLocalStorage
				});

				WebapiCommon.getNaoConformidades().then(result => {
					this.setState({ naoconformidades: result });
				});

				this.props.commonActions.showFadeCarregando(true);
				this.filtrar(
					this.state.tecnicoSelecionado && this.state.tecnicoSelecionado.value,
					this.state.periodoInicial,
					this.state.periodoFinal,
					this.state.numeroDoExame,
					this.state.numeroDoPedido,
					this.state.sortAsc
				);
			});
		}

		this.setState({periodos: this.obterListagemDePeriodos(this.props.intl)});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.mudou) {
			this.setState({ mudou: false });
			this.buscar();
		}

		if (this.state.sortAsc !== prevState.sortAsc) {
			setOrdenacaoKanban(this.state.sortAsc);
			this.buscar();
		}

		if (this.props.novasLaminas) {
			this.props.kanbanActions.atualizarNovasLaminas(false);
			this.props.commonActions.showFadeCarregando(true);
			let data = CommonFunctions.getPeriodosSubDays();
			this.setState({
				periodoInicial: data.periodoInicial,
				periodoFinal: data.periodoFinal,
				mudou: true
			});
		}
		if (this.props.organizarLotenovasLaminas) {
			this.props.organizarActions.atualizarNovasLaminas(false);
			this.props.commonActions.showFadeCarregando(true);
			let data = CommonFunctions.getPeriodosSubDays();
			this.setState({
				periodoInicial: data.periodoInicial,
				periodoFinal: data.periodoFinal,
				mudou: true
			});
		}
	}

	resetarPeriodo = () => {
		this.setState({periodo: '', periodoInicial: null, periodoFinal: null})
	}

	periodoAlterado = (e) => {
		if (!e || !e.value) {
		  return this.resetarPeriodo();
		}

		let payload = this.getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

		this.setState({
			periodo: e,
			periodoInicial: payload.dtinicial,
			periodoFinal: payload.dtfinal})
	}

	mudarIntervaloPeriodo = (val) => {
		let payload = this.changePeriod(val);

		this.setState({
			periodoInicial: payload.start,
			periodoFinal: payload.end})
	}

	eventoOnKeyPressData(event) {
		if (event.key === "Enter")
			this.buscar();
	}

	limparFiltro() {
		this.setState({
			periodoInicial: null,
			periodoFinal: null,
			periodo: '',
			tecnicoSelecionado: null,
			numeroDoExame: '',
			numeroDoPedido: '',
			laudoPesquisa: '',
			lista: []
		});
	}

	toggleModalImprimirBlocosEmLote = () =>
		this.setState(state => ({
			showModalImprimirBlocosEmLote: !state.showModalImprimirBlocosEmLote
		}));

	imprimirEtiquetaEmLote(blocosMarcados, cassete35 = false, cassete45 = false) {
		this.props.commonActions.showFadeCarregando(true);
		let blocos = [];
		let tipoModelo = cassete35 ? 'cassete35' :  cassete45 ? 'cassete45' : 'areatecnica'

		blocosMarcados.map(bloco => {
			let blocosParaEtiqueta = this.state.blocosParaEtiqueta;
			let blocoFiltrado = blocosParaEtiqueta.find(b => b.id === bloco);

			blocos.push({
				impressora: 'clawPDF',
				codigoBarra: blocoFiltrado.data.nrBloco,
				numeroExame: blocoFiltrado.data.nrBloco,
				numeroPedido: blocoFiltrado.data.numeroPedido.toString(),
				modelo: tipoModelo
			});

			return blocoFiltrado;
		});

		WebapiCommon.imprimirEtiquetaAreaTecnica(blocos, tipoModelo).then(data => {
			var url = CommonFunctions.getPdfBlob(data.pdf);
			this.props.commonActions.showFadeCarregando(false);
			this.setState({ url: url });
			this.setShow(!this.state.show);
		});
	}

	setShow(show) {
		this.setState({ show });

		if (!show && this.state.showModalImprimirBlocosEmLote) {
			this.toggleModalImprimirBlocosEmLote();
		}
	}

	openModal(identificador, nomeEtapa, modal) {
		var etapas = {
			cassetes: 0,
			executando: 1,
			blocos: 2
		};
		var bloco = this.state.lista[etapas[nomeEtapa]][nomeEtapa].find(b => {
			return b.id === identificador;
		});

		var exc = {
			id: bloco.data.id,
			label:
				bloco.data.nrBloco !== undefined
					? bloco.data.nrBloco
					: bloco.data.nrLamina,
			etapa: bloco.data.nrBloco !== undefined ? 1 : 2
		};
		this.setState({
			itemInModal: exc
		});

		if (modal === 'cancelar') {
			this.toggleModalCancelar();
		} else {
			this.toggleModalNaoConfor();
		}
	}

	toggleModalCancelar() {
		if (this.state.modalOpenCancelar) {
			this.setState({ modalOpenCancelar: false });
			this.filtrar(
				!!this.state.tecnicoSelecionado
					? this.state.tecnicoSelecionado.value
					: null,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame,
				this.state.numeroDoPedido,
				this.state.sortAsc
			);
		} else {
			this.setState({ modalOpenCancelar: true });
		}
	}

	toggleModalNaoConfor() {
		if (this.state.modalOpenNaoConfor) {
			this.setState({ modalOpenNaoConfor: false });
			this.filtrar(
				!!this.state.tecnicoSelecionado
					? this.state.tecnicoSelecionado.value
					: null,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame,
				this.state.numeroDoPedido,
				this.state.sortAsc
			);
		} else {
			this.setState({ modalOpenNaoConfor: true });
		}
	}

	filtrar(tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc) {
		this.props.commonActions.showFadeCarregando(true);

		HistologiaApi.getCassetes(tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc).then(res => {
			let lista = [];

			lista.push({
				cassetes: res.naoRealizado.map(cassete => this.montemItemKanban(cassete, quadroKanbanEnum.HI_CASSETE.id, quadroKanbanEnum.HI_CASSETE.icone)),
				title: {
					text: `${this.props.intl.formatMessage({ id: "dashboards.examDetail.cassettes" })}`,
					color: colorsSystem.DG1
				},
				count: res.naoRealizado.length
			});

			lista.push({
				executando: res.andamento.map(cassete => this.montemItemKanban(cassete, quadroKanbanEnum.HI_EXECUTANDO.id, quadroKanbanEnum.HI_EXECUTANDO.icone)),
				title: {
					text: `${this.props.intl.formatMessage({ id: "dashboards.reports.inProgress" })}`,
					color: colorsSystem.DG3
				},
				count: res.andamento.length
			});

			lista.push({
				blocos: res.finalizado.map(bloco => this.montemItemKanban(bloco, quadroKanbanEnum.HI_BLOCOS.id, quadroKanbanEnum.HI_BLOCOS.icone)),
				title: {
					text: `${this.props.intl.formatMessage({ id: "general.materialArchiving.blocks" })}`,
					color: colorsSystem.DG5
				},
				count: res.finalizado.length
			});

			let altura = this.calcularAlturaColunaKanbam(lista);

			this.setState({
				lista,
				altura,
				blocosParaEtiqueta: lista[2].blocos
			});

			this.props.commonActions.showFadeCarregando(false);

			if (res.naoRealizado.length === 0 && res.andamento.length === 0 && res.finalizado.length === 0) {
				this.props.commonActions.showAlerta('alerta', <IntlMessage id="dashboards.reports.noResultsFound" />, 1500);
			}
		});
	}

	calcularAlturaColunaKanbam = lista => {
		let cassetes = lista[0].cassetes;
		let executando = lista[1].executando;
		let blocos = lista[2].blocos;

		let alturaNavbarFiltroEhTitulos = 215;
		let alturaExtraNoFinalDaColunaParaAreaDeDrop = 100;
		let colunaMaiorTotalItens = cassetes.length;

		colunaMaiorTotalItens =
			executando.length > colunaMaiorTotalItens
				? executando.length
				: colunaMaiorTotalItens;

		colunaMaiorTotalItens =
			blocos.length > colunaMaiorTotalItens
				? blocos.length
				: colunaMaiorTotalItens;

		let altura =
			alturaNavbarFiltroEhTitulos +
			alturaExtraNoFinalDaColunaParaAreaDeDrop +
			colunaMaiorTotalItens * 90 +
			'px';

		return altura;
	};

	buscar() {
		if ((!this.state.tecnicoSelecionado || this.state.tecnicoSelecionado.value == null) &&
			this.state.numeroDoExame == '' &&
			this.state.numeroDoPedido == '' &&
			((this.state.periodoInicial == null) || this.state.periodoInicial == '') &&
			((this.state.periodoFinal == null) || this.state.periodoFinal == '')) {
				this.props.commonActions.showAlerta('alerta', this.props.intl.formatMessage({id: 'dashboards.general.noFilteredItems'}), 3000);
				return;
		}

		let executarValidacaoDeData =
			((this.state.periodoInicial != null) && this.state.periodoInicial != '') ||
			((this.state.periodoFinal != null) && this.state.periodoFinal != '');

		let datasValidas = !executarValidacaoDeData ? true :
			this.validarData(this.state.periodoInicial, this.state.periodoFinal, this.props.intl, this.props.commonActions);

		if (datasValidas) {
			this.props.commonActions.showFadeCarregando(true);

			this.filtrar(
				this.state.tecnicoSelecionado && this.state.tecnicoSelecionado.value,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame,
				this.state.numeroDoPedido,
				this.state.sortAsc);
		}
	}

	organizar() {
		this.props.organizarActions.atualizarModal(true);
	}

	onChangeData(name, value) {
		this.setState({[name]: value})
	}

	onChangeTecnico(tecnico) {
		this.setState({tecnicoSelecionado: tecnico});
	}

	atualizarListaNoState(lista, id, destino) {
		this.props.commonActions.showAlerta('sucesso', <IntlMessage id='dashboards.histology.successfullyMoved' />, 800);

		if (destino === quadroKanbanEnum.HI_CASSETE.id) {
			HistologiaApi.updateCassete(id, quadroKanbanEnum.HI_CASSETE.status);
			lista[0][quadroKanbanEnum.HI_CASSETE.id] = lista[0][
				quadroKanbanEnum.HI_CASSETE.id
			]
				.sort((a, b) => {
					return a.data.id - b.data.id;
				})
				.map(cassete =>
					this.montemItemKanban(
						cassete.data,
						quadroKanbanEnum.HI_CASSETE.id,
						quadroKanbanEnum.HI_CASSETE.icone
					)
				);
		}
		if (destino === quadroKanbanEnum.HI_EXECUTANDO.id) {
			HistologiaApi.updateCassete(id, quadroKanbanEnum.HI_EXECUTANDO.status);
			lista[1][quadroKanbanEnum.HI_EXECUTANDO.id] = lista[1][
				quadroKanbanEnum.HI_EXECUTANDO.id
			]
				.sort((a, b) => {
					return a.data.id - b.data.id;
				})
				.map(cassete =>
					this.montemItemKanban(
						cassete.data,
						quadroKanbanEnum.HI_EXECUTANDO.id,
						quadroKanbanEnum.HI_EXECUTANDO.icone
					)
				);
		}
		if (destino === quadroKanbanEnum.HI_BLOCOS.id) {
			HistologiaApi.updateCassete(id, quadroKanbanEnum.HI_BLOCOS.status);
			lista[2][quadroKanbanEnum.HI_BLOCOS.id] = lista[2][
				quadroKanbanEnum.HI_BLOCOS.id
			]
				.sort((a, b) => {
					return a.data.id - b.data.id;
				})
				.map(cassete =>
					this.montemItemKanban(
						cassete.data,
						quadroKanbanEnum.HI_BLOCOS.id,
						quadroKanbanEnum.HI_BLOCOS.icone
					)
				);
		}

		lista[0]['count'] = lista[0][quadroKanbanEnum.HI_CASSETE.id].length;
		lista[1]['count'] = lista[1][quadroKanbanEnum.HI_EXECUTANDO.id].length;
		lista[2]['count'] = lista[2][quadroKanbanEnum.HI_BLOCOS.id].length;

		let altura = this.calcularAlturaColunaKanbam(lista);

		this.setState({
			lista: lista,
			altura,
			blocosParaEtiqueta: lista[2].blocos
		});
	}

	montemItemKanban(cassete, etapa, icone) {
		return {
			id: cassete.id,
			data: cassete,
			isDragDisabled: cassete.bloqueado === 'S',
			content: (
				<Card
					intl={this.props.intl}
					item={cassete}
					icone={icone}
					etapa={etapa}
					openModal={this.openModal.bind(this)}
				/>
			)
		};
	}

	onChangeNumeroExame(event) {
		this.setState({
			numeroDoExame: event.currentTarget.value
		});
	}

	onClickOrdem() {
		this.setState({sortAsc: !this.state.sortAsc})
	}

	onKeyPressNumeroExame(event) {
		let {
			periodoInicial,
			periodoFinal,
			tecnicoSelecionado,
			numeroDoExame,
			sortAsc
		} = this.state;

		if (event.key === 'Enter') {
			this.filtrar(
				!!tecnicoSelecionado ? tecnicoSelecionado.value : null,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				null,
				sortAsc
			);
		}
	}

	onChangeNumeroPedido(event) {
		this.setState({
			numeroDoPedido: event.currentTarget.value
		});
	}

	onKeyPressNumeroPedido(event) {
		let {
			periodoInicial,
			periodoFinal,
			tecnicoSelecionado,
			numeroDoExame,
			numeroDoPedido,
			sortAsc
		} = this.state;

		if (event.key === 'Enter') {
			this.filtrar(
				!!tecnicoSelecionado ? tecnicoSelecionado.value : null,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				numeroDoPedido,
				sortAsc
			);
		}
	}

	render() {
		const { numeroDoExame, numeroDoPedido, altura } = this.state;
		return (
			<React.Fragment>
				<Preview
					show={this.state.show}
					setShow={this.setShow.bind(this)}
					url={this.state.url}
				/>
				<InclusaoPage
					limparFiltro={this.limparFiltro.bind(this)}
					history={this.props.history}
					lista={this.state.lista}
					tecnicos={this.state.tecnicos}
					tecnicoSelecionado={this.state.tecnicoSelecionado}
					periodoInicial={this.state.periodoInicial}
					periodoFinal={this.state.periodoFinal}
					onChangeData={this.onChangeData.bind(this)}
					onChangeTecnico={this.onChangeTecnico.bind(this)}
					atualizarListaNoState={this.atualizarListaNoState.bind(this)}
					modalOpenCancelar={this.state.modalOpenCancelar}
					toggleModalImprimirBlocosEmLote={this.toggleModalImprimirBlocosEmLote.bind(this)}
					imprimirEtiquetaEmLote={this.imprimirEtiquetaEmLote.bind(this)}
					showModalImprimirBlocosEmLote={this.state.showModalImprimirBlocosEmLote}
					blocosParaEtiqueta={this.state.blocosParaEtiqueta}
					toggleModalCancelar={this.toggleModalCancelar.bind(this)}
					itemInModal={this.state.itemInModal}
					modalOpenNaoConfor={this.state.modalOpenNaoConfor}
					toggleModalNaoConfor={this.toggleModalNaoConfor.bind(this)}
					naoconformidades={this.state.naoconformidades}
					usuarioLocal={this.state.usuarioLocal}
					onChangeNumeroExame={this.onChangeNumeroExame.bind(this)}
					onKeyPressNumeroExame={this.onKeyPressNumeroExame.bind(this)}
					sortAsc={this.state.sortAsc}
					onClickOrdem={this.onClickOrdem.bind(this)}
					buscar={this.buscar.bind(this)}
					organizar={this.organizar.bind(this)}
					numeroDoExame={numeroDoExame}
					altura={altura}
					periodos={this.state.periodos}
					periodo={this.state.periodo}
					onChangePeriodo={this.periodoAlterado.bind(this)}
					mudarIntervaloPeriodo={this.mudarIntervaloPeriodo.bind(this)}
					onKeyPressData={this.eventoOnKeyPressData.bind(this)}
					onChangeNumeroPedido={this.onChangeNumeroPedido.bind(this)}
					onKeyPressNumeroPedido={this.onKeyPressNumeroPedido.bind(this)}
					numeroDoPedido={numeroDoPedido}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		novasLaminas: state.kanban.novasLaminas,
		organizarLotenovasLaminas: state.organizarLote.novasLaminas
	};
};

const mapDispatchToProps = dispatch => {
	return {
		commonActions: bindActionCreators(commonActions, dispatch),
		kanbanActions: bindActionCreators(kanbanActions, dispatch),
		organizarActions: bindActionCreators(organizarActions, dispatch)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(InclusaoContainer);



// WEBPACK FOOTER //
// ./src/pages/histologia/inclusao/inclusao.container.js